import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useWarehouseModel } from "../warehouseModel";
import { IVRMWarehouseDetail } from "../warehouseTypes";
import useGlobalModel from "@/model/globalModel";
import { tableSize } from "@/utils/constants";

const columns: ColumnsType<IVRMWarehouseDetail> = [
    {
        title: '序号',
        fixed: "left",
        width: 60,
        align: "center",
        render: (t, r, i) => <>{i + 1}</>
    },
    // {
    //     title: '所属站点',
    //     width: 180,
    //     align: "center",
    //     dataIndex: 'shopName',
    // },
    {
        title: '仓库编号',
        width: 180,
        align: "center",
        dataIndex: 'code',
    },
    {
        title: '仓库名称',
        width: 180,
        align: "center",
        dataIndex: 'name',
    },
    {
        title: '仓库负责人',
        align: "center",
        dataIndex: 'contact',
    },
    {
        title: '联系电话',
        align: "center",
        dataIndex: 'phone',
    },
    {
        title: '联系地址',
        align: "center",
        dataIndex: 'address',
    },
    {
        title: '创建人',
        width: 120,
        dataIndex: 'createUser',
    },
    {
        title: '备注',
        align: "center",
        dataIndex: 'note',
    }
];

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useWarehouseModel();
    const { shopAndOrg: { shopCode } } = useGlobalModel()
    useEffect(() => {
        setSelectedRowKeys('');
    }, [shopCode])
    useEffect(() => {
        loadData();
    }, [])

    return (
        <Table
            bordered
            size={tableSize}
            rowKey={record => record.id as string}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                // ...pgCfg, 
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: event => setSelectedRowKeys(selectedRowKeys === record.id as string ? "" : record.id as string)
            })}
            rowClassName={(record, index) => record.id === selectedRowKeys ? "table-select-row" : ""}
            scroll={{ x: 'max-content', y: "calc(100vh - 210px)" }}
        />
    )
}
